import FormConfig from "../formChangeConfig.js";
import { fun_PostAction } from "@/api/index";
import {
  fun_CheckLockBrand,
  fun_ECCAInit,
  fun_GetExpirationDate,
  fun_GetLockNumber,
  fun_IsIe
} from "../../../../../utils/commonLock";
// 引入转译方法
import CaLock from "@/components/common/calock";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        tenderReference: null, // 招标编号
        registrationId: null, // 招标登记编号
        announcementId: null, // 招标公告编号
        constructionNo: null, // 报建编号
        prjName: null, // 项目名称
        section: null, // 标段号
        tenderContent: null, // 招标内容
        tenderContentNum: null, // 招标内容编号
        tenderClassNumName: null, // 招标类别
        tenderTypeNumName: null, // 招标方式
        corpName: null, // 中标单位名称
        basicInfoId: null, // 中标单位名称编号
        personName: null, // 项目经理名称
        winningPrice: null, // 中标价（万元）
        state: null, // 状态
        stateName: null, // 状态名称
        regulators: null, // 区管代码
        regulatorsName: null, // 区管代码名称
        constructorId: null, // 项目负责人编号
        idCard: null, // 项目负责人身份证
        chageIdCard: null, // 变更后项目负责人身份证
        regLockBrand: null, // 锁品牌
        regBasicinfoChange: null, // 更换后的项目负责人主键
        basicinfoChangeName: null, // 更换后的项目经理（总监）名称
        unionPersonName: null, // 项目负责人名称
        oldLockBrand: null, // 锁品牌
        oldPersonId: null, // 旧锁负责人编号
        unionAgreementId: null, // 联合投标编号
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
      },
      // 表单错误
      errRules: {},
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 全局加载
      fullLoading: null,
      // 数字证书数组
      regLockBrands: [],
      /******************************************项目负责人/总监变更记录******************************************/
      // 项目负责人/总监变更记录loading
      changeLoading: false,
      // 项目负责人/总监变更记录表数据
      changeTableData: [],
      // 项目负责人/总监变更记录列表基础数据
      changeTableColumns: [
        {
          label: "变更前项目负责人/总监姓名",
          prop: "regBasicinfoName",
        },
        {
          label: "变更前项目负责人/总监证件号码",
          prop: "regBasicinfoIdCard"
        },
        {
          label: "变更后项目负责人/总监姓名",
          prop: "basicinfoChangeName"
        },
        {
          label: "变更后项目负责人/总监证件号码",
          prop: "regBasicinfoChangeCard"
        },
        {
          label: "状态",
          slotName: "state",
          width: "100"
        },
        {
          label: "审核意见",
          slotName: "op",
          width: "120"
        },
      ],
      // 分页
      changeReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      changeTotal: 0, // 总条数
      auditRecordNumber: null // 审核历史数据编号
    };
  },
  // 注册组件
  components: {
    CaLock, // CA锁
    AuditHistoryRecord, // 历史核验记录
    TenderPictureinfor // 附件页面
  },
// 接收父组件传递的数据
  props: {
    // 页面类型
    controllerFlg: {
      type: String
    },
    // 文件类型
    type: {
      type: String
    },
    // 数据编号
    id: {
      type: String
    },
  },
  // 模板编译完成
  mounted() {

  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open(){
      // 打开loading
      this.loading = true;
      // 获取详情信息
      this.fun_Details();
      // 数字证书下拉框
      this.fun_GetLockBrandSelect();
    },
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/contractProjectManager/changeDetail", {
        id: this.id,
        controllerFlg: this.controllerFlg
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 页面样式设置
          this.fun_PageStyle();
          // 项目负责人/总监变更记录一览
          this.fun_ChangeList();
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 项目负责人/总监变更记录一览
     * @author 任少杰
     */
    fun_ChangeList() {
      // 打开加载
      this.changeLoading = true;
      // 发起请求
      fun_PostAction("/contractProjectManager/recordChangeList", {
        tenderReference: this.id,
        type: "11"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 列表数据
          this.changeTableData = records;
          // 获取分页总条数
          this.changeTotal = total;
        }
        // 关闭加载
        this.changeLoading = false;
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_ChangeLimitChange(e) {
      // 获取每页显示条数
      this.changeReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_ChangePageChange(e) {
      // 获取当前页码
      this.changeReqPageData.current = e;
      // 获取一览表格数据
      this.fun_ChangeList();
    },
    /**
     * 获取数字证书下拉框
     */
    fun_GetLockBrandSelect() {
      // 请求，获取结果集
      fun_PostAction("/dataDictionaryEntries/DictionaryCombobox", {
        zdid: "201512281759580003"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 数字证书下拉框
          this.regLockBrands = data;
        }
      });
    },
    /**
     * 设置页面样式
     */
    fun_PageStyle(){
      // 如果是详情
      if(this.controllerFlg == "detail"){
        // 定义CA证书类型
        let arr = ["oldLockBrand"];
        // 删除字段
        this.formConfigList[0].formConfigList = this.formConfigList[0].formConfigList.filter(
            e => !arr.includes(e.value)
        );
        // 遍历
        this.formConfigList.map(item => {
          // 遍历
          item.formConfigList.map(e => {
            // 禁止输入
            e.disabled = true;
          })
        })
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 回显字段
      this.form[i] = e;
    },
    /**
     * @description 保存
     * @author
     */
    fun_InsUpd(state) {
      // 验证当前表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 状态赋值
          this.form.state = state;
          // CA证书类型数量
          let num = 0;
          // 遍历表单
          this.formConfigList[0].formConfigList.map((e, i) => {
            // 如果是"CA证书类型"
            if (e.value == "oldLockBrand") {
              num++;
            }
          });
          // 如果存在旧ca证书类型
          if(num > 0){
            // 如果旧ca锁验证为空
            if(!this.form.oldLockBrand){
              // 提示
              this.$message.error("项目负责人（总监）未读取锁信息，请确认后选择！");
              return;
            }
            // 原项目负责人与读取原锁信息不一致，则提示
            if(this.form.oldPersonId != this.form.constructorId){
              // 提示
              this.$message.error("项目负责人（总监）不一致，请使用原项目负责人（总监）的CA锁或app账号重新操作！");
              return;
            }
          }
          // 原项目负责人与变更后项目负责人一致，则提示
          if(this.form.regBasicinfoChange == this.form.constructorId){
            // 提示
            this.$message.error("不能变更为同一项目负责人！");
            return;
          }
          // 打开遮罩
          this.fun_Loading();
          // 项目经理与单位检查
          this.fun_CheckCorpWork(state);
        } else {
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 项目经理与单位检查
     * @author shuhua
     */
    fun_CheckCorpWork(state) {
      // 创建中标候选人信息集合
      let winCandidates = new Array();
      // 初始化中标候选人信息
      let pmInfo = {"basicInfoId":"","xmjlsfz":"","xmjlxm":""};
      // 企业编号
      pmInfo.basicInfoId = this.form.basicInfoId;
      // 项目负责人身份证
      pmInfo.xmjlsfz = this.form.chageIdCard;
      // 项目负责人姓名
      pmInfo.xmjlxm =  this.form.basicinfoChangeName;
      // 加入集合
      winCandidates.push(pmInfo);
      // 发起请求
      fun_PostAction("/winningPublicity/checkCorpWork", {
        tenderReference: "null",
        winCandidates: JSON.stringify(winCandidates),
        tenderContentNum: this.form.tenderContentNum,
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 如果是提交
          if(state == "tj"){
            // 开启弹窗
            this.$refs.caLock.dialogCalock = true;
            // 签名数据, 交易人名称和日期
            this.$refs.caLock.data =
                this.form.prjName +
                this.form.constructionNo +
                this.form.corpName +
                this.form.personName;
            // 状态
            this.$refs.caLock.state = state;
          }else{
            // 提交数据
            this.fun_Submit();
          }
        } else {
          // 错误提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 弹出询问confirm
      this.$confirm("确定进行提交操作吗？提交后将不能修改信息，请谨慎操作！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 提交数据
        this.fun_Submit();
      });
    },
    /**
     * 提交后台
     */
    fun_Submit(){
      // 打开遮罩
      this.fun_Loading();
      // 请求
      fun_PostAction("/contractProjectManager/saveOrUpdateChange", {
        ...this.form, // form表单数据
        controllerFlg: this.controllerFlg // 操作标志
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.fun_Back();
        } else {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 打开核验记录弹窗
     */
    fun_OpenAuditRecord(e) {
      // 赋值审核历史数据编号
      this.auditRecordNumber = e.id;
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 赋值审核历史数据编号
      this.auditRecordNumber = this.form.id;
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor() {
      // 打开弹窗
      this.$refs.tenderPictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.tenderPictureinfor.fun_GetOpen();
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行效验，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 读取数字证书信息
     */
    fun_OldRegPersonInfoChoose(){
      // 遮罩框加载
      this.fun_Loading();
      // 初始化
      fun_IsIe();
      // CA自动检测
      let lockBrand = fun_CheckLockBrand();
      // 是否检测到锁品牌
      if (lockBrand == "" || lockBrand == null) {
        // 加载框取消
        this.fullLoading.close();
        // 提示
        this.$message.error("请检查是否插入CA锁或者是否安装CA驱动，请确认后重新提交！");
        return;
      }
      // 控件初始化
      if (!fun_ECCAInit()) {
        // 加载框取消
        this.fullLoading.close();
        return;
      }
      // 设置锁品牌
      this.$set(this.form, "oldLockBrand", lockBrand);
      // 锁编号
      let lockNo = fun_GetLockNumber();
      // 证书到期日
      let expirationDate = fun_GetExpirationDate();
      // 请求，获取结果集
      fun_PostAction("/caLock/checkRegPersonCaInfo", {
        lockNo: lockNo, // 锁编号
        lockBrand: lockBrand, // 锁品牌
        expirationDate: expirationDate, // 证书到期日
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 设置旧项目负责人编号
          this.form.oldPersonId = data.regPersonId;
          // 原项目负责人编号不等于读取锁编号
          if(this.form.constructorId != data.regPersonId){
            // 提示
            this.$message.error("项目负责人（总监）不一致，请使用原项目负责人（总监）的CA锁或app账号重新操作！");
            return;
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 读取数字证书信息
     * @author shuhua
     */
    fun_RegPersonInfoChoose() {
      // 遮罩框加载
      this.fun_Loading();
      // 初始化
      fun_IsIe();
      // CA自动检测
      let lockBrand = fun_CheckLockBrand();
      // 是否检测到锁品牌
      if (lockBrand == "" || lockBrand == null) {
        // 加载框取消
        this.fullLoading.close();
        // 提示
        this.$message.error("请检查是否插入CA锁或者是否安装CA驱动，请确认后重新提交！");
        return;
      }
      // 控件初始化
      if (!fun_ECCAInit()) {
        // 加载框取消
        this.fullLoading.close();
        return;
      }
      // 设置锁品牌
      this.$set(this.form, "regLockBrand", lockBrand);
      // 锁编号
      let lockNo = fun_GetLockNumber();
      // 证书到期日
      let expirationDate = fun_GetExpirationDate();
      // 请求，获取结果集
      fun_PostAction("/caLock/checkRegPersonCaInfo", {
        lockNo: lockNo, // 锁编号
        lockBrand: lockBrand, // 锁品牌
        expirationDate: expirationDate, // 证书到期日
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 项目负责人主键
          this.form.regBasicinfoChange = data.regPersonId;
          // 项目负责人名称
          this.form.basicinfoChangeName = data.regPersonName;
          // 项目负责人证件类型名称
          this.form.idCardTypeName = data.idCardTypeName;
          // 项目负责人证件号码
          this.form.chageIdCard = data.idCard;
        } else {
          this.$message.error(msg);
        }
      });
    },
  }
};
